import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { lastValueFrom, map } from 'rxjs';

import { ConfigService } from '@services';

import { Contact } from '@models';

@Injectable({
    providedIn: 'root'
})

export class AuthenticationService {

    constructor(
        private configService: ConfigService,
        private httpClient: HttpClient,
    ) { }

    public login(email: string, password: string) {
        const url = this.configService.restApiUrl + '/auth/login';
        const body = {
            email,
            password
        };
        return lastValueFrom(
            this.httpClient.post<{ contact: Contact, is_superuser: boolean, expires: string }>(url, body, { withCredentials: true })
                .pipe(map(response => response))
        );
    }

    public logout() {
        const url = this.configService.restApiUrl + '/auth/logout';
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            withCredentials: true
        };
        return lastValueFrom(this.httpClient.get<string>(url, httpOptions).pipe(map(response => response)));
    }

    public ping() {
        const url = this.configService.restApiUrl + '/auth/ping';
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return lastValueFrom(this.httpClient.get<{ data: string }>(url, httpOptions).pipe(map(response => response)));
    }
}
